import { render, staticRenderFns } from "./Distribution.vue?vue&type=template&id=5b0b2ea5&scoped=true&"
import script from "./Distribution.vue?vue&type=script&lang=ts&"
export * from "./Distribution.vue?vue&type=script&lang=ts&"
import style0 from "./Distribution.vue?vue&type=style&index=0&id=5b0b2ea5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b0b2ea5",
  null
  
)

export default component.exports